/* @flow */
import * as React from 'react';
import TooltipTrigger from 'components/TooltipTrigger.jsx';

/* ************************************** */
/* DEPRECATED: Use TooltipTrigger instead */
/* ************************************** */

type TooltipableProps = {
  tooltip?: React.Node,
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left',
  tooltipAlignment?: 'top' | 'right' | 'bottom' | 'left',
};

/* HOC
 *
 * Make any component tooltip ready
 * this mean any parent component can add tooltip to
 * the wrapper component by passing a tooltip prop to it.
 */
// $FlowFixMe incompatible instantiation
export default function tooltipable<Props: {}>(Component: React.ComponentType<Props>) {
  class Wrapper extends React.Component<TooltipableProps> {
    // $FlowFixMe property `displayName` not found in Component object type
    static displayName = Component.displayName || Component.name;

    render() {
      const { tooltip, tooltipPlacement, tooltipAlignment, ...rest } = this.props;

      if (!tooltip) {
        // $FlowIssue
        return <Component {...this.props} />;
      }

      return (
        <TooltipTrigger tooltip={tooltip} placement={tooltipPlacement} alignment={tooltipAlignment}>
          {/* $FlowIssue */}
          <Component {...rest} />
        </TooltipTrigger>
      );
    }
  }

  return Wrapper;
}
